<template>
<div :class="['micad_formElement micad_formElement_dropdown', getType(type)]">
    <label class="micad_formElement_label">{{label}}</label>
    <div class="micad_formElement_control">
        <select class="micad_formElement_control_input">
        <option >Please choose</option>
        <option v-for="item in items" :key="item">{{item}}</option>
        </select>        
    </div>
    <div class="micad_formElement_message">{{message}}</div>
</div>
</template>

<script>
export default {
  name: 'Dropdowns',
  data() {
    return {
        label: "Quisque tristique.",
        items: ["Item 1", "Item 2", "Item 3", "Item 4", "Item 5", "Item 6"],
        message: "Quisque tristique quis leo vitae luctus."
        }
    },
    props: {
        type: String,
    },
    methods: {
        getType(type) {
            if (type !== undefined) {
                return ' micad_formElement_'+type
            }
        }
    }
};
</script>
